// Auto-generated Match Detail image imports
// Generated on: 2026-04-15T04:05:50.110Z

import { Setting } from '@bz/request';

import matchDetailSoccerCoolBlack from '../BZimg/MatchDetail/001Soccer/CoolBlack.png';
import matchDetailSoccerBakosBlue from '../BZimg/MatchDetail/001Soccer/BakosBlue.png';
import matchDetailSoccerPlaster from '../BZimg/MatchDetail/001Soccer/Plaster.png';
import matchDetailBasketballCoolBlack from '../BZimg/MatchDetail/002Basketball/CoolBlack.png';
import matchDetailBasketballBakosBlue from '../BZimg/MatchDetail/002Basketball/BakosBlue.png';
import matchDetailBasketballPlaster from '../BZimg/MatchDetail/002Basketball/Plaster.png';
import matchDetailBaseballCoolBlack from '../BZimg/MatchDetail/003Baseball/CoolBlack.png';
import matchDetailBaseballBakosBlue from '../BZimg/MatchDetail/003Baseball/BakosBlue.png';
import matchDetailBaseballPlaster from '../BZimg/MatchDetail/003Baseball/Plaster.png';
import matchDetailIceHockeyCoolBlack from '../BZimg/MatchDetail/004Icehockey/CoolBlack.png';
import matchDetailIceHockeyBakosBlue from '../BZimg/MatchDetail/004Icehockey/BakosBlue.png';
import matchDetailIceHockeyPlaster from '../BZimg/MatchDetail/004Icehockey/Plaster.png';
import matchDetailTennisCoolBlack from '../BZimg/MatchDetail/005Tennis/CoolBlack.png';
import matchDetailTennisBakosBlue from '../BZimg/MatchDetail/005Tennis/BakosBlue.png';
import matchDetailTennisPlaster from '../BZimg/MatchDetail/005Tennis/Plaster.png';
import matchDetailHandballCoolBlack from '../BZimg/MatchDetail/006Handball/CoolBlack.png';
import matchDetailHandballBakosBlue from '../BZimg/MatchDetail/006Handball/BakosBlue.png';
import matchDetailHandballPlaster from '../BZimg/MatchDetail/006Handball/Plaster.png';
import matchDetailFloorballCoolBlack from '../BZimg/MatchDetail/007Floorball/CoolBlack.png';
import matchDetailFloorballBakosBlue from '../BZimg/MatchDetail/007Floorball/BakosBlue.png';
import matchDetailFloorballPlaster from '../BZimg/MatchDetail/007Floorball/Plaster.png';
import matchDetailBoxingCoolBlack from '../BZimg/MatchDetail/010Boxing/CoolBlack.png';
import matchDetailBoxingBakosBlue from '../BZimg/MatchDetail/010Boxing/BakosBlue.png';
import matchDetailBoxingPlaster from '../BZimg/MatchDetail/010Boxing/Plaster.png';
import matchDetailRugbyCoolBlack from '../BZimg/MatchDetail/012Rugby/CoolBlack.png';
import matchDetailRugbyBakosBlue from '../BZimg/MatchDetail/012Rugby/BakosBlue.png';
import matchDetailRugbyPlaster from '../BZimg/MatchDetail/012Rugby/Plaster.png';
import matchDetailAussieRulesCoolBlack from '../BZimg/MatchDetail/013Aussierules/CoolBlack.png';
import matchDetailAussieRulesBakosBlue from '../BZimg/MatchDetail/013Aussierules/BakosBlue.png';
import matchDetailAussieRulesPlaster from '../BZimg/MatchDetail/013Aussierules/Plaster.png';
import matchDetailBandyCoolBlack from '../BZimg/MatchDetail/015Bandy/CoolBlack.png';
import matchDetailBandyBakosBlue from '../BZimg/MatchDetail/015Bandy/BakosBlue.png';
import matchDetailBandyPlaster from '../BZimg/MatchDetail/015Bandy/Plaster.png';
import matchDetailAmericanFootballCoolBlack from '../BZimg/MatchDetail/016AmericanFootball/CoolBlack.png';
import matchDetailAmericanFootballBakosBlue from '../BZimg/MatchDetail/016AmericanFootball/BakosBlue.png';
import matchDetailAmericanFootballPlaster from '../BZimg/MatchDetail/016AmericanFootball/Plaster.png';
import matchDetailSnookerCoolBlack from '../BZimg/MatchDetail/019Snooker/CoolBlack.png';
import matchDetailSnookerBakosBlue from '../BZimg/MatchDetail/019Snooker/BakosBlue.png';
import matchDetailSnookerPlaster from '../BZimg/MatchDetail/019Snooker/Plaster.png';
import matchDetailTableTennisCoolBlack from '../BZimg/MatchDetail/020TableTennis/CoolBlack.png';
import matchDetailTableTennisBakosBlue from '../BZimg/MatchDetail/020TableTennis/BakosBlue.png';
import matchDetailTableTennisPlaster from '../BZimg/MatchDetail/020TableTennis/Plaster.png';
import matchDetailCricketCoolBlack from '../BZimg/MatchDetail/021Cricket/CoolBlack.png';
import matchDetailCricketBakosBlue from '../BZimg/MatchDetail/021Cricket/BakosBlue.png';
import matchDetailCricketPlaster from '../BZimg/MatchDetail/021Cricket/Plaster.png';
import matchDetailDartsCoolBlack from '../BZimg/MatchDetail/022Darts/CoolBlack.png';
import matchDetailDartsBakosBlue from '../BZimg/MatchDetail/022Darts/BakosBlue.png';
import matchDetailDartsPlaster from '../BZimg/MatchDetail/022Darts/Plaster.png';
import matchDetailVolleyballCoolBlack from '../BZimg/MatchDetail/023Volleyball/CoolBlack.png';
import matchDetailVolleyballBakosBlue from '../BZimg/MatchDetail/023Volleyball/BakosBlue.png';
import matchDetailVolleyballPlaster from '../BZimg/MatchDetail/023Volleyball/Plaster.png';
import matchDetailFieldHockeyCoolBlack from '../BZimg/MatchDetail/024Fieldhockey/CoolBlack.png';
import matchDetailFieldHockeyBakosBlue from '../BZimg/MatchDetail/024Fieldhockey/BakosBlue.png';
import matchDetailFieldHockeyPlaster from '../BZimg/MatchDetail/024Fieldhockey/Plaster.png';
import matchDetailWaterpoloCoolBlack from '../BZimg/MatchDetail/026Waterpolo/CoolBlack.png';
import matchDetailWaterpoloBakosBlue from '../BZimg/MatchDetail/026Waterpolo/BakosBlue.png';
import matchDetailWaterpoloPlaster from '../BZimg/MatchDetail/026Waterpolo/Plaster.png';
import matchDetailCurlingCoolBlack from '../BZimg/MatchDetail/028Curling/CoolBlack.png';
import matchDetailCurlingBakosBlue from '../BZimg/MatchDetail/028Curling/BakosBlue.png';
import matchDetailCurlingPlaster from '../BZimg/MatchDetail/028Curling/Plaster.png';
import matchDetailFutsalCoolBlack from '../BZimg/MatchDetail/029Futsal/CoolBlack.png';
import matchDetailFutsalBakosBlue from '../BZimg/MatchDetail/029Futsal/BakosBlue.png';
import matchDetailFutsalPlaster from '../BZimg/MatchDetail/029Futsal/Plaster.png';
import matchDetailBadmintonCoolBlack from '../BZimg/MatchDetail/031Badminton/CoolBlack.png';
import matchDetailBadmintonBakosBlue from '../BZimg/MatchDetail/031Badminton/BakosBlue.png';
import matchDetailBadmintonPlaster from '../BZimg/MatchDetail/031Badminton/Plaster.png';
import matchDetailChessCoolBlack from '../BZimg/MatchDetail/033Chess/CoolBlack.png';
import matchDetailChessBakosBlue from '../BZimg/MatchDetail/033Chess/BakosBlue.png';
import matchDetailChessPlaster from '../BZimg/MatchDetail/033Chess/Plaster.png';
import matchDetailSquashCoolBlack from '../BZimg/MatchDetail/037Squash/CoolBlack.png';
import matchDetailSquashBakosBlue from '../BZimg/MatchDetail/037Squash/BakosBlue.png';
import matchDetailSquashPlaster from '../BZimg/MatchDetail/037Squash/Plaster.png';
import matchDetailEsportCounterStrikeCoolBlack from '../BZimg/MatchDetail/109EsportCounterStrike/CoolBlack.png';
import matchDetailEsportCounterStrikeBakosBlue from '../BZimg/MatchDetail/109EsportCounterStrike/BakosBlue.png';
import matchDetailEsportCounterStrikePlaster from '../BZimg/MatchDetail/109EsportCounterStrike/Plaster.png';
import matchDetailEsportLeagueOfLegendsCoolBlack from '../BZimg/MatchDetail/110EsportLeagueOfLegends/CoolBlack.png';
import matchDetailEsportLeagueOfLegendsBakosBlue from '../BZimg/MatchDetail/110EsportLeagueOfLegends/BakosBlue.png';
import matchDetailEsportLeagueOfLegendsPlaster from '../BZimg/MatchDetail/110EsportLeagueOfLegends/Plaster.png';
import matchDetailEsportDotaCoolBlack from '../BZimg/MatchDetail/111EsportDota/CoolBlack.png';
import matchDetailEsportDotaBakosBlue from '../BZimg/MatchDetail/111EsportDota/BakosBlue.png';
import matchDetailEsportDotaPlaster from '../BZimg/MatchDetail/111EsportDota/Plaster.png';
import matchDetailMmaCoolBlack from '../BZimg/MatchDetail/117Mma/CoolBlack.png';
import matchDetailMmaBakosBlue from '../BZimg/MatchDetail/117Mma/BakosBlue.png';
import matchDetailMmaPlaster from '../BZimg/MatchDetail/117Mma/Plaster.png';
import matchDetailEsportCallOfDutyCoolBlack from '../BZimg/MatchDetail/118EsportCallOfDuty/CoolBlack.png';
import matchDetailEsportCallOfDutyBakosBlue from '../BZimg/MatchDetail/118EsportCallOfDuty/BakosBlue.png';
import matchDetailEsportCallOfDutyPlaster from '../BZimg/MatchDetail/118EsportCallOfDuty/Plaster.png';
import matchDetailEsportRainbowSixCoolBlack from '../BZimg/MatchDetail/125EsportRainbowSix/CoolBlack.png';
import matchDetailEsportRainbowSixBakosBlue from '../BZimg/MatchDetail/125EsportRainbowSix/BakosBlue.png';
import matchDetailEsportRainbowSixPlaster from '../BZimg/MatchDetail/125EsportRainbowSix/Plaster.png';
import matchDetailESportKingOfGloryCoolBlack from '../BZimg/MatchDetail/134ESportKingofGlory/CoolBlack.png';
import matchDetailESportKingOfGloryBakosBlue from '../BZimg/MatchDetail/134ESportKingofGlory/BakosBlue.png';
import matchDetailESportKingOfGloryPlaster from '../BZimg/MatchDetail/134ESportKingofGlory/Plaster.png';
import matchDetailGaelicFootballCoolBlack from '../BZimg/MatchDetail/135Gaelicfootball/CoolBlack.png';
import matchDetailGaelicFootballBakosBlue from '../BZimg/MatchDetail/135Gaelicfootball/BakosBlue.png';
import matchDetailGaelicFootballPlaster from '../BZimg/MatchDetail/135Gaelicfootball/Plaster.png';
import matchDetailGaelicHurlingCoolBlack from '../BZimg/MatchDetail/136Gaelichurling/CoolBlack.png';
import matchDetailGaelicHurlingBakosBlue from '../BZimg/MatchDetail/136Gaelichurling/BakosBlue.png';
import matchDetailGaelicHurlingPlaster from '../BZimg/MatchDetail/136Gaelichurling/Plaster.png';
import matchDetailESoccerCoolBlack from '../BZimg/MatchDetail/137ESoccer/CoolBlack.png';
import matchDetailESoccerBakosBlue from '../BZimg/MatchDetail/137ESoccer/BakosBlue.png';
import matchDetailESoccerPlaster from '../BZimg/MatchDetail/137ESoccer/Plaster.png';
import matchDetailKabaddiCoolBlack from '../BZimg/MatchDetail/138Kabaddi/CoolBlack.png';
import matchDetailKabaddiBakosBlue from '../BZimg/MatchDetail/138Kabaddi/BakosBlue.png';
import matchDetailKabaddiPlaster from '../BZimg/MatchDetail/138Kabaddi/Plaster.png';
import matchDetailEBasketballCoolBlack from '../BZimg/MatchDetail/153EBasketball/CoolBlack.png';
import matchDetailEBasketballBakosBlue from '../BZimg/MatchDetail/153EBasketball/BakosBlue.png';
import matchDetailEBasketballPlaster from '../BZimg/MatchDetail/153EBasketball/Plaster.png';
import matchDetailEsportArenaOfValorCoolBlack from '../BZimg/MatchDetail/158EsportArenaOfValor/CoolBlack.png';
import matchDetailEsportArenaOfValorBakosBlue from '../BZimg/MatchDetail/158EsportArenaOfValor/BakosBlue.png';
import matchDetailEsportArenaOfValorPlaster from '../BZimg/MatchDetail/158EsportArenaOfValor/Plaster.png';
import matchDetailECricketCoolBlack from '../BZimg/MatchDetail/197ECricket/CoolBlack.png';
import matchDetailECricketBakosBlue from '../BZimg/MatchDetail/197ECricket/BakosBlue.png';
import matchDetailECricketPlaster from '../BZimg/MatchDetail/197ECricket/Plaster.png';
import matchDetailGeneralCoolBlack from '../BZimg/MatchDetail/General/CoolBlack.png';
import matchDetailGeneralBakosBlue from '../BZimg/MatchDetail/General/BakosBlue.png';
import matchDetailGeneralPlaster from '../BZimg/MatchDetail/General/Plaster.png';
import scoreBoardTimingCoolBlack from '../BZimg/MatchDetail/ScoreBoardTiming/CoolBlack.png';
import scoreBoardTimingBakosBlue from '../BZimg/MatchDetail/ScoreBoardTiming/BakosBlue.png';
import scoreBoardTimingPlaster from '../BZimg/MatchDetail/ScoreBoardTiming/Plaster.png';

import { SportIdMap } from '~/constants';

export const matchDetailThemeAssets = {
  ['matchdetail_' + SportIdMap.SOCCER]: {
    [Setting.Theme.cool]: matchDetailSoccerCoolBlack,
    [Setting.Theme.bakos]: matchDetailSoccerBakosBlue,
    [Setting.Theme.plaster]: matchDetailSoccerPlaster,
  },
  ['matchdetail_' + SportIdMap.BASKETBALL]: {
    [Setting.Theme.cool]: matchDetailBasketballCoolBlack,
    [Setting.Theme.bakos]: matchDetailBasketballBakosBlue,
    [Setting.Theme.plaster]: matchDetailBasketballPlaster,
  },
  ['matchdetail_' + SportIdMap.BASEBALL]: {
    [Setting.Theme.cool]: matchDetailBaseballCoolBlack,
    [Setting.Theme.bakos]: matchDetailBaseballBakosBlue,
    [Setting.Theme.plaster]: matchDetailBaseballPlaster,
  },
  ['matchdetail_' + SportIdMap.ICE_HOCKEY]: {
    [Setting.Theme.cool]: matchDetailIceHockeyCoolBlack,
    [Setting.Theme.bakos]: matchDetailIceHockeyBakosBlue,
    [Setting.Theme.plaster]: matchDetailIceHockeyPlaster,
  },
  ['matchdetail_' + SportIdMap.TENNIS]: {
    [Setting.Theme.cool]: matchDetailTennisCoolBlack,
    [Setting.Theme.bakos]: matchDetailTennisBakosBlue,
    [Setting.Theme.plaster]: matchDetailTennisPlaster,
  },
  ['matchdetail_' + SportIdMap.HANDBALL]: {
    [Setting.Theme.cool]: matchDetailHandballCoolBlack,
    [Setting.Theme.bakos]: matchDetailHandballBakosBlue,
    [Setting.Theme.plaster]: matchDetailHandballPlaster,
  },
  ['matchdetail_' + SportIdMap.FLOORBALL]: {
    [Setting.Theme.cool]: matchDetailFloorballCoolBlack,
    [Setting.Theme.bakos]: matchDetailFloorballBakosBlue,
    [Setting.Theme.plaster]: matchDetailFloorballPlaster,
  },
  ['matchdetail_' + SportIdMap.BOXING]: {
    [Setting.Theme.cool]: matchDetailBoxingCoolBlack,
    [Setting.Theme.bakos]: matchDetailBoxingBakosBlue,
    [Setting.Theme.plaster]: matchDetailBoxingPlaster,
  },
  ['matchdetail_' + SportIdMap.RUGBY]: {
    [Setting.Theme.cool]: matchDetailRugbyCoolBlack,
    [Setting.Theme.bakos]: matchDetailRugbyBakosBlue,
    [Setting.Theme.plaster]: matchDetailRugbyPlaster,
  },
  ['matchdetail_' + SportIdMap.AUSSIE_RULES]: {
    [Setting.Theme.cool]: matchDetailAussieRulesCoolBlack,
    [Setting.Theme.bakos]: matchDetailAussieRulesBakosBlue,
    [Setting.Theme.plaster]: matchDetailAussieRulesPlaster,
  },
  ['matchdetail_' + SportIdMap.BANDY]: {
    [Setting.Theme.cool]: matchDetailBandyCoolBlack,
    [Setting.Theme.bakos]: matchDetailBandyBakosBlue,
    [Setting.Theme.plaster]: matchDetailBandyPlaster,
  },
  ['matchdetail_' + SportIdMap.AMERICAN_FOOTBALL]: {
    [Setting.Theme.cool]: matchDetailAmericanFootballCoolBlack,
    [Setting.Theme.bakos]: matchDetailAmericanFootballBakosBlue,
    [Setting.Theme.plaster]: matchDetailAmericanFootballPlaster,
  },
  ['matchdetail_' + SportIdMap.SNOOKER]: {
    [Setting.Theme.cool]: matchDetailSnookerCoolBlack,
    [Setting.Theme.bakos]: matchDetailSnookerBakosBlue,
    [Setting.Theme.plaster]: matchDetailSnookerPlaster,
  },
  ['matchdetail_' + SportIdMap.TABLE_TENNIS]: {
    [Setting.Theme.cool]: matchDetailTableTennisCoolBlack,
    [Setting.Theme.bakos]: matchDetailTableTennisBakosBlue,
    [Setting.Theme.plaster]: matchDetailTableTennisPlaster,
  },
  ['matchdetail_' + SportIdMap.CRICKET]: {
    [Setting.Theme.cool]: matchDetailCricketCoolBlack,
    [Setting.Theme.bakos]: matchDetailCricketBakosBlue,
    [Setting.Theme.plaster]: matchDetailCricketPlaster,
  },
  ['matchdetail_' + SportIdMap.DARTS]: {
    [Setting.Theme.cool]: matchDetailDartsCoolBlack,
    [Setting.Theme.bakos]: matchDetailDartsBakosBlue,
    [Setting.Theme.plaster]: matchDetailDartsPlaster,
  },
  ['matchdetail_' + SportIdMap.VOLLEYBALL]: {
    [Setting.Theme.cool]: matchDetailVolleyballCoolBlack,
    [Setting.Theme.bakos]: matchDetailVolleyballBakosBlue,
    [Setting.Theme.plaster]: matchDetailVolleyballPlaster,
  },
  ['matchdetail_' + SportIdMap.FIELD_HOCKEY]: {
    [Setting.Theme.cool]: matchDetailFieldHockeyCoolBlack,
    [Setting.Theme.bakos]: matchDetailFieldHockeyBakosBlue,
    [Setting.Theme.plaster]: matchDetailFieldHockeyPlaster,
  },
  ['matchdetail_' + SportIdMap.WATERPOLO]: {
    [Setting.Theme.cool]: matchDetailWaterpoloCoolBlack,
    [Setting.Theme.bakos]: matchDetailWaterpoloBakosBlue,
    [Setting.Theme.plaster]: matchDetailWaterpoloPlaster,
  },
  ['matchdetail_' + SportIdMap.CURLING]: {
    [Setting.Theme.cool]: matchDetailCurlingCoolBlack,
    [Setting.Theme.bakos]: matchDetailCurlingBakosBlue,
    [Setting.Theme.plaster]: matchDetailCurlingPlaster,
  },
  ['matchdetail_' + SportIdMap.FUTSAL]: {
    [Setting.Theme.cool]: matchDetailFutsalCoolBlack,
    [Setting.Theme.bakos]: matchDetailFutsalBakosBlue,
    [Setting.Theme.plaster]: matchDetailFutsalPlaster,
  },
  ['matchdetail_' + SportIdMap.BADMINTON]: {
    [Setting.Theme.cool]: matchDetailBadmintonCoolBlack,
    [Setting.Theme.bakos]: matchDetailBadmintonBakosBlue,
    [Setting.Theme.plaster]: matchDetailBadmintonPlaster,
  },
  ['matchdetail_' + SportIdMap.CHESS]: {
    [Setting.Theme.cool]: matchDetailChessCoolBlack,
    [Setting.Theme.bakos]: matchDetailChessBakosBlue,
    [Setting.Theme.plaster]: matchDetailChessPlaster,
  },
  ['matchdetail_' + SportIdMap.SQUASH]: {
    [Setting.Theme.cool]: matchDetailSquashCoolBlack,
    [Setting.Theme.bakos]: matchDetailSquashBakosBlue,
    [Setting.Theme.plaster]: matchDetailSquashPlaster,
  },
  ['matchdetail_' + SportIdMap.ESPORT_COUNTER_STRIKE]: {
    [Setting.Theme.cool]: matchDetailEsportCounterStrikeCoolBlack,
    [Setting.Theme.bakos]: matchDetailEsportCounterStrikeBakosBlue,
    [Setting.Theme.plaster]: matchDetailEsportCounterStrikePlaster,
  },
  ['matchdetail_' + SportIdMap.ESPORT_LEAGUE_OF_LEGENDS]: {
    [Setting.Theme.cool]: matchDetailEsportLeagueOfLegendsCoolBlack,
    [Setting.Theme.bakos]: matchDetailEsportLeagueOfLegendsBakosBlue,
    [Setting.Theme.plaster]: matchDetailEsportLeagueOfLegendsPlaster,
  },
  ['matchdetail_' + SportIdMap.ESPORT_DOTA]: {
    [Setting.Theme.cool]: matchDetailEsportDotaCoolBlack,
    [Setting.Theme.bakos]: matchDetailEsportDotaBakosBlue,
    [Setting.Theme.plaster]: matchDetailEsportDotaPlaster,
  },
  ['matchdetail_' + SportIdMap.MMA]: {
    [Setting.Theme.cool]: matchDetailMmaCoolBlack,
    [Setting.Theme.bakos]: matchDetailMmaBakosBlue,
    [Setting.Theme.plaster]: matchDetailMmaPlaster,
  },
  ['matchdetail_' + SportIdMap.ESPORT_CALL_OF_DUTY]: {
    [Setting.Theme.cool]: matchDetailEsportCallOfDutyCoolBlack,
    [Setting.Theme.bakos]: matchDetailEsportCallOfDutyBakosBlue,
    [Setting.Theme.plaster]: matchDetailEsportCallOfDutyPlaster,
  },
  ['matchdetail_' + SportIdMap.ESPORT_RAINBOW_SIX]: {
    [Setting.Theme.cool]: matchDetailEsportRainbowSixCoolBlack,
    [Setting.Theme.bakos]: matchDetailEsportRainbowSixBakosBlue,
    [Setting.Theme.plaster]: matchDetailEsportRainbowSixPlaster,
  },
  ['matchdetail_' + SportIdMap.ESPORT_KING_OF_GLORY]: {
    [Setting.Theme.cool]: matchDetailESportKingOfGloryCoolBlack,
    [Setting.Theme.bakos]: matchDetailESportKingOfGloryBakosBlue,
    [Setting.Theme.plaster]: matchDetailESportKingOfGloryPlaster,
  },
  ['matchdetail_' + SportIdMap.GAELIC_FOOTBALL]: {
    [Setting.Theme.cool]: matchDetailGaelicFootballCoolBlack,
    [Setting.Theme.bakos]: matchDetailGaelicFootballBakosBlue,
    [Setting.Theme.plaster]: matchDetailGaelicFootballPlaster,
  },
  ['matchdetail_' + SportIdMap.GAELIC_HURLING]: {
    [Setting.Theme.cool]: matchDetailGaelicHurlingCoolBlack,
    [Setting.Theme.bakos]: matchDetailGaelicHurlingBakosBlue,
    [Setting.Theme.plaster]: matchDetailGaelicHurlingPlaster,
  },
  ['matchdetail_' + SportIdMap.ESOCCER]: {
    [Setting.Theme.cool]: matchDetailESoccerCoolBlack,
    [Setting.Theme.bakos]: matchDetailESoccerBakosBlue,
    [Setting.Theme.plaster]: matchDetailESoccerPlaster,
  },
  ['matchdetail_' + SportIdMap.KABADDI]: {
    [Setting.Theme.cool]: matchDetailKabaddiCoolBlack,
    [Setting.Theme.bakos]: matchDetailKabaddiBakosBlue,
    [Setting.Theme.plaster]: matchDetailKabaddiPlaster,
  },
  ['matchdetail_' + SportIdMap.EBASKETBALL]: {
    [Setting.Theme.cool]: matchDetailEBasketballCoolBlack,
    [Setting.Theme.bakos]: matchDetailEBasketballBakosBlue,
    [Setting.Theme.plaster]: matchDetailEBasketballPlaster,
  },
  ['matchdetail_' + SportIdMap.ESPORT_ARENA_OF_VALOR]: {
    [Setting.Theme.cool]: matchDetailEsportArenaOfValorCoolBlack,
    [Setting.Theme.bakos]: matchDetailEsportArenaOfValorBakosBlue,
    [Setting.Theme.plaster]: matchDetailEsportArenaOfValorPlaster,
  },
  ['matchdetail_' + SportIdMap.ECRICKET]: {
    [Setting.Theme.cool]: matchDetailECricketCoolBlack,
    [Setting.Theme.bakos]: matchDetailECricketBakosBlue,
    [Setting.Theme.plaster]: matchDetailECricketPlaster,
  },
  ['matchdetail_general']: {
    [Setting.Theme.cool]: matchDetailGeneralCoolBlack,
    [Setting.Theme.bakos]: matchDetailGeneralBakosBlue,
    [Setting.Theme.plaster]: matchDetailGeneralPlaster,
  },
  ['scoreboard_timing']: {
    [Setting.Theme.cool]: scoreBoardTimingCoolBlack,
    [Setting.Theme.bakos]: scoreBoardTimingBakosBlue,
    [Setting.Theme.plaster]: scoreBoardTimingPlaster,
  },
};
